import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Marcas } from '../_model/marcas';
import { MarcasService } from '../_services/marcas.service';

@Component({
    selector: 'app-acessorios',
    templateUrl: './acessorios.component.html',
    styleUrls: ['./acessorios.component.less'],
    standalone: false
})
export class AcessoriosComponent implements OnInit {

  constructor(private marca: MarcasService) { }

  marcas: Marcas[] = [];
  apiUrl: string = environment.apiUrl;

  ngOnInit() {
    this.marca.listPathOrder('acess').subscribe((data: any) => {
      data.forEach(el => {
        this.marcas.push(new Marcas(el));
      });
    });
  }

  link(item: Marcas):string {
    return item.link == '' ? "/produtos?query=&marca="+item.id+"&type="+item.tipo : (item.link.includes("http") ? item.link : "https://"+item.link);
  }

}
